import styled from 'styled-components'
import {useNavigate} from 'react-router-dom'
import {getCurrentColors} from '../../utils/colors'
import LeftBar from '../home/components/leftBar'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import DescriptionIcon from '@mui/icons-material/Description'
import LinkIcon from '@mui/icons-material/Link'

const COLORS = getCurrentColors() // Importando as cores do tema atual

const Page = styled.div`
    display: flex;
    height: 100vh;
    overflow: hidden !important;
`

const Content = styled.div`
    flex: 1;
    padding: 64px 48px;
    background-color: #f6f8fa;
    overflow-y: auto;
`

const CardsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 32px;
`

const Card = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 220px;
    padding: 32px 16px;
    border: none;
    border-radius: 10px;
    background-color: ${COLORS.branco};
    box-shadow: 1px 1px 3px 1px #d4d3d3;
    cursor: pointer;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: ${COLORS.cinzaEscuro};
    transition: all 0.3s;

    svg {
        font-size: 40px;
        color: #39cab7;
    }

    &:hover {
        box-shadow: 1px 1px 6px 2px #c4c3c3;
    }
`

export default function AdminMenu() {
    const navigate = useNavigate()

    return (
        <Page>
            <LeftBar />
            <Content>
                <h1>Admin</h1>
                <p style={{color: '#707070'}}>
                    Selecione a tela administrativa que deseja acessar
                </p>
                <CardsWrapper>
                    <Card onClick={() => navigate('/flowPage')}>
                        <AccountTreeIcon />
                        Editor de Fluxo
                    </Card>
                    <Card onClick={() => navigate('/upload-documents')}>
                        <DescriptionIcon />
                        Editor de Minutas
                    </Card>
                    <Card onClick={() => navigate('/flowOrganizationsPage')}>
                        <LinkIcon />
                        Fluxos x Organizações
                    </Card>
                </CardsWrapper>
            </Content>
        </Page>
    )
}
